/* eslint-disable max-len */
export default {
    BaseSaveToWorkspace: {
        Main: {
            cancel: '取消',
            submit: '确定',
            saveToWorkspaceLink: '正在添加，稍后请到工作空间“{link}”文件夹查看',
            title: '保存到工作空间',
        },
        FolderSelector: {
            label: '选择文件夹',
            addWorkspace: '添加工作空间',
            searchFolderInputPlaceholder: '快速查找文件夹',
            noData: {
                workspace: '暂无工作空间',
                folder: '暂无文件夹',
                search: '未找到对应文件夹',
            },
            newFolderName: '新建文件夹',
            newWorkspaceName: '新建工作空间',
            workspaceGroupType: {
                public: '企业工作空间',
                shared: '来自分享的工作空间',
                self: '个人工作空间',
            },
            lastFlag: {
                ADD: '最近保存',
                COPY: '最近复制',
                MOVE: '最近移动',
                RELATED: '项目关联',
            },
        },
        RangeSelector: {
            from: '从',
            to: '到',
            title: '请选择范围',
            selectAllLabel: '选择所有',
            family: {
                label: '保存所有专利及其同族专利',
                types: {
                    SIMPLE: '所有专利及其简单同族专利',
                    INPADOC: '所有专利及其INPADOC同族专利',
                    EXTEND: '所有专利及其PatSnap同族专利',
                    APNO: '所有专利及其同申请号专利',
                },
                error: '同族数据异常，请取消后重试。',
            },
            tip: '若搜索结果设置分组显示，则范围选择的专利为代表专利',
            selectAllFamilyLabel: '选择所有 {allCounts} 个同族',
            selectAllFamilyPatentCountLabel: '<span style="color: #8993A4">（{count} 件专利）</span>',
            familyLabel: '（{count} 件专利）',
            selectFamilyLabel: '选择了 {allCounts} 个同族 <span style="color: #8993A4">（{count} 件专利）</span>',
        },
        AutoUpdate: {
            otherSettingLabel: '其它设置',
            label: '有新专利时自动更新至该文件夹',
            viewQuery: '查看检索式',
            tip: '若文件夹已经开启过自动收录，则无法重复开启收录另一个检索式。仅在全选专利（且不同时保存同族专利）时，可开启自动收录。',
            refine: '过滤',
            familylabel: '有新的族命中时自动更新至该文件夹',
            familyTip: '若文件夹内已开启「按检索式自动更新」，则本次设置将不生效',
        },
        PAPER: {
            RangeSelector: {
                simpleSelectLabel: '已选择 <span class="s2w-simple-count">{count}</span> 篇文献',
                error: {
                    invalidError: '请输入合理的范围',
                    overMaxCountError: '输入的范围数值不能超过{limit}',
                    rangeError: '单次最多可以保存{limit}条',
                },
            },
        },
        PATENT: {
            RangeSelector: {
                simpleSelectLabel: '已选择 <span class="s2w-simple-count">{count}</span> 件专利',
                error: {
                    invalidError: '@:BaseSaveToWorkspace.PAPER.RangeSelector.error.invalidError',
                    overMaxCountError: '@:BaseSaveToWorkspace.PAPER.RangeSelector.error.overMaxCountError',
                    rangeError: '@:BaseSaveToWorkspace.PAPER.RangeSelector.error.rangeError',
                    disabledSelectAllError: '超过文件夹可保存上限{limit}',
                    familyRangeError: '单次最多保存 {limit} 个族',
                },
            },
        },
        VC: {
            RangeSelector: {
                simpleSelectLabel: '已选择 <span class="s2w-simple-count">{count}</span> 条风险投资',
                error: {
                    invalidError: '@:BaseSaveToWorkspace.PAPER.RangeSelector.error.invalidError',
                    overMaxCountError: '@:BaseSaveToWorkspace.PAPER.RangeSelector.error.overMaxCountError',
                    rangeError: '单次最多可以保存{limit}条风险投资',
                },
            },
        },
        MA: {
            RangeSelector: {
                simpleSelectLabel: '已选择 <span class="s2w-simple-count">{count}</span> 条企业兼并',
                error: {
                    invalidError: '@:BaseSaveToWorkspace.PAPER.RangeSelector.error.invalidError',
                    overMaxCountError: '@:BaseSaveToWorkspace.PAPER.RangeSelector.error.overMaxCountError',
                    rangeError: '单次最多可以保存{limit}条企业兼并',
                },
            },
        },
        MR: {
            RangeSelector: {
                simpleSelectLabel: '已选择 <span class="s2w-simple-count">{count}</span> 条市场报告',
                error: {
                    invalidError: '@:BaseSaveToWorkspace.PAPER.RangeSelector.error.invalidError',
                    overMaxCountError: '@:BaseSaveToWorkspace.PAPER.RangeSelector.error.overMaxCountError',
                    rangeError: '单次最多可以保存{limit}条市场报告',
                },
            },
        },
        DRUG: {
            RangeSelector: {
                simpleSelectLabel: '已选择 <span class="s2w-simple-count">{count}</span> 条药物',
                error: {
                    invalidError: '@:BaseSaveToWorkspace.PAPER.RangeSelector.error.invalidError',
                    overMaxCountError: '@:BaseSaveToWorkspace.PAPER.RangeSelector.error.overMaxCountError',
                    rangeError: '单次最多可以保存{limit}条药物',
                },
            },
        },
        CLINICAL: {
            RangeSelector: {
                simpleSelectLabel: '已选择 <span class="s2w-simple-count">{count}</span> 条临床试验',
                error: {
                    invalidError: '@:BaseSaveToWorkspace.PAPER.RangeSelector.error.invalidError',
                    overMaxCountError: '@:BaseSaveToWorkspace.PAPER.RangeSelector.error.overMaxCountError',
                    rangeError: '单次最多可以保存{limit}条临床试验',
                },
            },
        },
        sequence: {
            selected: '已勾选',
            sequences: '条序列',
        },
    },
};
